import React from 'react'

import { Flex, Grid } from '@primitives/Layout'
import { InlineLink } from '../shared/InlineLink'

export const SupportLink = () => {
  return (
    <InlineLink to="/support" fontSize={1}>
      ← Support
    </InlineLink>
  )
}

export const NavTabsVersionHistory = ({ app }) => {
  return (
    <Grid
      width="100%"
      gridTemplateColumns="50% 50%"
      gridColumnGap={2}
      fontSize={1}
    >
      <Flex
        flex={1}
        alignItems="center"
        justifyContent="center"
        bg="#fafafa"
        py={2}
        width="100%"
        style={{
          borderRadius: 8
        }}
      >
        <InlineLink to={`/support/${app.toLowerCase()}/`} lineHeight="normal">
          {app} Help
        </InlineLink>
      </Flex>
      <Flex
        bg="#e9e9e9"
        py={2}
        width="100%"
        alignItems="center"
        justifyContent="center"
        style={{
          borderRadius: 8
        }}
        flex={1}
      >
        Version History
      </Flex>
    </Grid>
  )
}

const WHATSNEW_APPS = new Set(['timepage', 'actions', 'flow'])

export const NavTabsHelp = ({ app, categoryId }) => {
  if (!WHATSNEW_APPS.has(categoryId)) {
    return null
  }

  return (
    <Grid
      width="100%"
      gridTemplateColumns="50% 50%"
      gridColumnGap={2}
      fontSize={1}
    >
      <Flex
        bg="#e9e9e9"
        py={2}
        width="100%"
        alignItems="center"
        justifyContent="center"
        style={{
          borderRadius: 8
        }}
        flex={1}
      >
        {app} Help
      </Flex>
      <Flex
        flex={1}
        alignItems="center"
        justifyContent="center"
        bg="#fafafa"
        py={2}
        width="100%"
        style={{
          borderRadius: 8
        }}
      >
        <InlineLink to={`/new/${app.toLowerCase()}/`} lineHeight="normal">
          Version History
        </InlineLink>
      </Flex>
    </Grid>
  )
}
